<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.PackageCode }}</td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy persistent @save="saveItem({ID: item.ID, NumberOfPack: item.NumberOfPack})">
                    <div>{{ item.NumberOfPack | currency }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.NumberOfPack"
                        type="number"
                        :step="1"
                        label="Số kiện"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-bind:style="{ 'color': text_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.CustomsDate | display_date }}</td>
                <td>{{ item.StoreVNImportDate | display_date }}</td>
                <td class="text-center" v-if="userRole > 0">
                  <v-icon medium @click="deleteItem(item.ID)" class="pa-2">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
    </v-layout>
    <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/ma_van_don_mau.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "upload-file": upload_file,
    "store-popup": store
  },
  data() {
    return {
      shipping_methods: configs.SHIPPING_METHOD,
      product_types: configs.PRODUCT_TYPE,
      package_status: configs.PACKAGE_STATUS,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false,
      dataImport: '',
      importStep: 0,
      importUID: 0,
      appLoading: false,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.storeManager.all.data,
      total_rows: state => state.storeManager.all.total,
      currentItem: state => state.storeManager.selected,
      loading: state => state.storeManager.loading,
      customers: state => state.customer.all.data
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let tmp_headers = [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Nhập kho TQ",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thông quan",
          value: "CustomsDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Nhập kho VN",
          value: "StoreVNImportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thao tác",
          align: "center",
        }
      ];
      return tmp_headers;
    }
  },
  methods: {
    filter_data: function() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.userRole === 0, invisibleimportButton: this.userRole === 0, invisibleexportButton: this.userRole === 0});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("storeManager/getList", param);
      this.getCustomerList();
      this.appLoading = false;
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("storeManager/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$store.commit("storeManager/setDetail", {
        data: {
          ID: 0,
          TransactionCode: "",
          FeeShip: 0
        }
      });
      this.dialogStoreManager = true;
    },
    saveItem(item) {
      this.$store.dispatch("storeManager/setDetail", {
        'data': item,
        'id': item.ID
      });
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Email"]
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    text_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    export_show() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("storeManager/export", param);
    },
    import_show() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
          const formData = new FormData();
          formData.append('excel_file', f);
          formData.append('filename', f.name);
          this.$store.dispatch("storeManager/import", formData);
      }
      this.dialogImport = false;
    },
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: this.userRole === 0, invisibleimportButton: this.userRole === 0, invisibleexportButton: this.userRole === 0});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_IMPORT_DATA", this.import_show);
    this.$root.$on("REQUEST_EXPORT_DATA", this.export_show);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("storeManager/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_IMPORT_DATA", this.import_show);
    this.$root.$off("REQUEST_EXPORT_DATA", this.export_show);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
